import { render, staticRenderFns } from "./sub_programme.vue?vue&type=template&id=4c937964&scoped=true&"
import script from "./sub_programme.vue?vue&type=script&lang=js&"
export * from "./sub_programme.vue?vue&type=script&lang=js&"
import style0 from "./sub_programme.vue?vue&type=style&index=0&id=4c937964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c937964",
  null
  
)

export default component.exports